import ServiceBase from "@app/shared/serviceBase";

export default class NewMeasuresService extends ServiceBase {

  public async getNewMeasuresConnectionTest(): Promise<boolean> {
    const result = await this.makeGet<boolean>(`newmeasures/connection-test`);

    return result;
  }
}